import type { RolloutStatus } from '@/api/priceRollout'

/** Eine Tabellenzeile: einzelner Rollout oder das gekoppelte Paar Basis + eBay (Plan 2026-10-19 S2.3). */
export type RolloutZeile =
  | { art: 'einzeln'; r: RolloutStatus }
  | { art: 'paar'; basis: RolloutStatus; ebay: RolloutStatus }

/**
 * Basis und eBay (beide ohne Konto) desselben Artikels laufen gekoppelt und stehen als EINE Zeile
 * an der Stelle des zuerst gelisteten Partners. Alle anderen Rollouts bleiben einzeln, Reihenfolge stabil.
 */
export function gruppiereRollouts(rows: readonly RolloutStatus[]): RolloutZeile[] {
  const partner = new Map<string, RolloutStatus>()
  for (const r of rows) {
    if (r.account === null && (r.portal === 'base' || r.portal === 'ebay')) partner.set(`${r.stock_item_id}|${r.portal}`, r)
  }
  const verbraucht = new Set<number>()
  const out: RolloutZeile[] = []
  for (const r of rows) {
    if (verbraucht.has(r.id)) continue
    if (r.account === null && (r.portal === 'base' || r.portal === 'ebay')) {
      const anderer = partner.get(`${r.stock_item_id}|${r.portal === 'base' ? 'ebay' : 'base'}`)
      if (anderer) {
        verbraucht.add(anderer.id)
        out.push(r.portal === 'base' ? { art: 'paar', basis: r, ebay: anderer } : { art: 'paar', basis: anderer, ebay: r })
        continue
      }
    }
    out.push({ art: 'einzeln', r })
  }
  return out
}
